import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function StartupsCard({ result = [] }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          <Box sx={{ height: 25, width: 25, mr: 1, overflow: 'hidden' }}>
            <img src="/images/Startup.png" style={{ marginTop: '-8px' }} alt="" />
          </Box>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.markeet.startups.title')}</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          {/* LAP-733 (GE022) */}
          <Box sx={{ color: 'gray' }}>{t('investments.markeet.startups.subtitle')}</Box>
        </Box>
      </Box>
      <Box mt={1} height={'100%'} display={'flex'} flexDirection={'column'} gap={1}>
        {result.map((item, index) => (
          <Box key={index} display={'flex'}>
            <Box sx={{ width: 150, display: 'flex', overflow: 'hidden', mr: '8px' }}>
              <img src={item.image} alt="" />
            </Box>
            <Box>
              <Box>
                {item.name}
                <Box component={'span'} color={'gray'}>
                  {' '}
                  - {item.sector}- {item.localisation}
                </Box>
              </Box>
              <Box fontSize={11} py={2}>
                {/* LAP-733 (GE022) */}
                <Box>{t('investments.markeet.startups.amountSought')}: {item.price}€</Box>
                <Box>{item.investor} {t('investments.markeet.startups.investors')}</Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
